import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-daisyui';
import Modal, { ModalProps } from '@/components/modals/Modal/Modal.tsx';

const RefinementLimitModal: FC<ModalProps> = ({ onClose, ...modalProps }) => {
  const { t } = useTranslation();

  return (
    <Modal.Wrapper wrapperClassName="w-[440px]" {...modalProps} onClose={onClose} showCloseButton={false} closeable>
      <Modal.Title>
        <h2 className="font-feature text-center text-2xl font-bold italic">{t('refinementLimitModal.title')}</h2>
      </Modal.Title>

      <p className="text-center text-sm text-text-secondary">{t('refinementLimitModal.description')}</p>

      <Modal.Nav>
        {({ handleClose }) => (
          <Button type="button" color="primary" className="w-full" onClick={handleClose}>
            {t('button.gotIt')}
          </Button>
        )}
      </Modal.Nav>
    </Modal.Wrapper>
  );
};

export default RefinementLimitModal;
